'use strict';

import { forEach, debounce } from 'lodash';

import containerManager from '../../01-helpers/filter-context/container-manager';
import { publish, subscribe } from '../../01-helpers/event-manager';

import { FILTER_CHANGED, UPDATE_SEARCH } from '../../02-const/event-names';

import FilterInput from '../../04-components/filtering/filter-input';


const moduleName = 'filter-query',
	selectors = {
		base: `.js-${moduleName}`,
		input: `.js-${moduleName}-input`,
		submit: `.js-${moduleName}-submit`
	},
	attributeNames = {
		dataRefresh: 'data-refresh'
	};

export default class FilterQuery extends FilterInput {

	constructor(baseElement) {
		super(baseElement);
	}

	/**
	 * configure the class
	 * @param {any} baseElement
	 */
	_configure(baseElement) {
		this.baseElement = baseElement;
		this.inputs = this.baseElement.querySelectorAll('input');
		this.submitButton = this.baseElement.querySelector(selectors.submit);
		this.filterContext = containerManager.getContainer();
    }

	_updateFilterContext(element) {
		const value = element.value;
		let query = this.filterContext.state.SearchQuery;

		query = value || '';

		return query;
	}

	_setValue(evt) {
		const query = event?.detail?.q,
			input = this.baseElement.querySelector(selectors.input);

		input.value = query || '';

		this._triggerFilterUpdate(input);
	}

	_triggerFilterUpdate(element) {
		const refresh = element.getAttribute(attributeNames.dataRefresh),
			sq = this._updateFilterContext(element);

		// Update the filterContext
		this.filterContext.update(
			{
				SearchQuery: sq,
				NodeId: this.NodeId,
				Page: this.Page,
				Filters: this.filterContext.state.Filters
			},
			{ refresh: refresh === 'true' }
		);

		publish(FILTER_CHANGED);
    }

	/**
	 * on Submit handler 
	 * @param {any} evt
	 */
	_onSubmitEventHandler(evt) {
		evt.preventDefault();
		// get value and update filterContext
		const element = this.baseElement.querySelector(selectors.input);

		this._triggerFilterUpdate(element);
		
		return false;
	}

	_bindEvents() {

		this.baseElement.addEventListener('submit', debounce((event) => {
				this._onSubmitEventHandler(event)
			}, 100), true
		);

		subscribe(UPDATE_SEARCH, (event) => this._setValue(event));

		//forEach(this.inputs, (input) => {
		//	//if input is checked trigger onchange event
		//	if (input.checked || (input.type === 'date' && !isEmpty(input.value))) {
		//		const evt = document.createEvent("HTMLEvents");
		//		evt.initEvent("change", false, true);
		//		input.dispatchEvent(evt);
		//	}
		//});
	}
}

/* ========================================================================== */

const initFilterQuery = () => {
	forEach(document.querySelectorAll(selectors.base), (selectionElement) => {
		new FilterQuery(selectionElement);
	});
};

initFilterQuery();